import _styled from "styled-components";
import * as DTP from "./DateTimePickerStyles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CenturyView = _ref => {
  let {
    datesObject,
    onSelectCentury
  } = _ref;
  const centuries = datesObject.index;
  if (datesObject.dates && datesObject.dates.length >= 12) {
    return /*#__PURE__*/_jsxs(DTP.Grid, {
      children: [/*#__PURE__*/_jsx(DTP.GridHeading, {
        children: "Select a century"
      }), centuries.map(c => /*#__PURE__*/_jsxs(_StyledDTPDateButton, {
        onClick: () => onSelectCentury(c),
        children: [c, "00"]
      }, c))]
    });
  } else {
    // Note: This will be handled separately
    return null;
  }
};
var _StyledDTPDateButton = _styled(DTP.DateButton).withConfig({
  displayName: "CenturyView___StyledDTPDateButton",
  componentId: "sc-388xpj-0"
})(["display:inline-block;width:40%;"]);